import store from '../state/store'
import axios from 'axios'
import _ from 'underscore'
import { getQueryStringHash, updateLocation } from '../nav'

store.on('backlog_items:index', function(params = {}) {
  const backlog = store.get().backlog

  let getParams = {
    filter: backlog.filter,
    manager_id: backlog.manager_id,
    coordinator_id: backlog.coordinator_id
  }

  getParams = _.extend(getParams, params)

  axios.get("/api/sales/backlog_items", {params: getParams})
  .then(function(response) { 
    store.get().backlog.set(response.data)
  })
  .catch(function(error) {
    handleError(error)
  })
  .then(function() { 
    store.get().ui.set({loading_unclaimed_backlog: false})
  })
})

store.on('backlog_items:unclaimed:index', function() {
  axios.get("/api/sales/backlog_items/unclaimed")
  .then(function(response) {
    store.get().backlog.set(response.data)
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('backlog_items:show', function(params = {}) {
  axios.get(`/api/sales/backlog_items/${params.item_id}`, {params: params})
  .then(function(response) { 
    const updated_backlog_item = response.data.backlog_item

    if (updated_backlog_item.states.includes('deactivated') || updated_backlog_item.states.includes('converted')) {
      const index = _.findIndex(store.get().backlog.items, (item) => {
        return (item.item_id == params.item_id) && (item.item_type == params.item_type)
      })

      if (index > -1) {
        store.get().backlog.items.splice(index, 1)
      }
    }
    else {
      const backlog_item = _.find(store.get().backlog.items, function(item) {
        return (item.item_id == params.item_id) && (item.item_type == params.item_type)
      })

      if (backlog_item) {
        backlog_item.set(updated_backlog_item)
      }
      else {
        store.get().backlog.items.push(updated_backlog_item)
      }
    }
  })
  .catch(function(error) {
    handleError(error)
  })
})

store.on('backlog_items:claim_one', function(queue, params = {}) {
  store.get().ui.set({loading_unclaimed_backlog: true})

  const postParams = {
    queue: queue
  }

  axios.post("/api/sales/backlog_items/claim_one", postParams)
  .then(function(response) {
    const item = response.data.item

    if (params.newTab) {
      if (item.item_type === 'Sales::Enquiry') {
        window.open(`/?e=${item.item_id}`)
      }
      else if (item.item_type === 'Sales::Lead') {
        window.open(`/?l=${item.item_id}`)
      }
      else if (item.item_type === 'Placement::PlacementRequest') {
        if (item.lesson_plan_id) {
          window.open(`/?e=${item.enquiry_id}&t=lp${item.lesson_plan_id}&lpt=placement`)
        }
        else {
          // Admin-owned job: backlog_items:select already opens it in a new tab.
          store.emit('backlog_items:select', item)
        }
      }
    }
    else {
      if (item.item_type === 'Sales::Enquiry') {
        store.emit('backlog_items:select', item)
      }
      else if (item.item_type === 'Sales::Lead') {
        store.emit('backlog_items:select', item)
      }
      else if (item.item_type === 'Placement::PlacementRequest') {
        store.emit('backlog_items:select', item)
      }
    }

    store.emit('backlog_items:index', {filter: 'my_tasks'})
  })
  .catch(function(error) {
    handleError(error)
  })
  .then(function() { 
    store.get().ui.set({loading_unclaimed_backlog: false})
  })
})

store.on('backlog_items:select', function(item) {
  store.get().set({backlog_item_selection: item})

  if (item.item_type === 'Sales::Enquiry') {
    store.emit('enquiries:show', item.item_id);
  } else if (item.item_type === 'Sales::Lead') {
    store.emit('leads:show', item.item_id)
  } else if (item.item_type === 'Placement::PlacementRequest') {
    if (item.lesson_plan_id) {
      // Sales-owned job: open its lesson plan internally on the placement tab, no reload.
      // Write the query string first so switchEnquiryTab honours `lpt` (it only does when
      // the URL's `e` already matches the target enquiry).
      const search = getQueryStringHash()
      search.e = item.enquiry_id
      search.t = `lp${item.lesson_plan_id}`
      search.lpt = 'placement'
      updateLocation({ search })
      store.emit('enquiries:show', item.enquiry_id, `lp${item.lesson_plan_id}`)
    } else if (item.tutoring_plan_id) {
      // Admin-owned job: open the tutoring plan in the admin portal.
      const adminBase = import.meta.env.VITE_ADMIN_ENDPOINT || 'https://admin.teachme2.com'
      window.open(`${adminBase}/tutoring_plans/${item.tutoring_plan_id}/tutors`, '_blank', 'noopener,noreferrer')
    }
  }
})
